import { createContext, useReducer } from 'react';
import { stockControlModel } from '../../models/StockControlEntity'


export const StockControlContext = createContext();

const StockControlProvider = ({ children, stockControl = stockControlModel }) => {
    const reducer = (state, action) => {
        switch (action.type) {
            case 'EDIT':
                return {
                    ...state,
                    ...action.payload,
                }
            case 'REPLACE': {
                return action.stockControl
            }
            default:
                return state
        }
    }

    return (
        <StockControlContext.Provider value={useReducer(reducer, { ...stockControlModel, ...stockControl })}>
            {children}
        </StockControlContext.Provider>
    )
}

export default StockControlProvider;